export default {
  en: {
    snack: {
      card_delete_success: 'Card deleted successfully',
      subscribe: {
        on: 'Successfully subscribed',
        off: 'Successfully unsubscribed',
      },
      bookmark: {
        on: 'Successfully bookmarked',
        off: 'Successfully removed bookmark',
      },
      pin: {
        on: 'Successfully pinned',
        off: 'Successfully unpinned',
      },
    },
    confirm_dialog_msg: {
      default: 'Are you sure?',
      block: {
        user: "Are you sure?\n• You won't see any content from the user\n• You will not be able to chat privately anymore\n• In the group chat you will be able to see all the messages, regardless of whether user is blocked or not\n• You won't be able to send group invitations to each other anymore",
        group:
          "Are you sure?\n• You won't see any content from the group\n• You will not see the group in the group overview\n• The group can't send you any invitations",
      },
    },
    actions: {
      subscribe: {
        on: 'Turn off notifications',
        off: 'Turn on notifications',
      },
      bookmark: {
        on: 'Remove from Bookmarked',
        off: 'Bookmark',
      },
      pin: {
        on: 'Unpin',
        off: 'Pin',
      },
      block: {
        user: 'Block user',
        group: 'Block group',
      },
      unblock: {
        user: 'Unblock user',
        group: 'Unblock group',
      },
      contact: 'Contact',
      inappropriate_report: 'Report as inappropriate',
      settings: 'Settings',
      duplicate: 'Duplicate',
      admin: 'Admin',
    },
  },
};
